import { PageTitle } from "@/components/pageTitle";

export const Problem = () => {
  return (
    <div className="flex justify-center ">
      <div className=" pt-[77px] px-[240px] pb-[100px] w-[1920px]">
        <PageTitle title="企业开展全球业务面临的问题" />
        <div className="flex gap-[40px] justify-between mt-[80px]">
          <Item
            img="/imgs/kwan/1.png"
            title="全球办公网络波动大，体验差影响效率"
          />
          <Item img="/imgs/kwan/2.png" title="跨国区域受限制、访问难、易封号" />
        </div>
        <div className="flex gap-[40px] justify-between mt-[40px]">
          <Item img="/imgs/kwan/3.png" title="自建专线部署价格高、周期长" />
          <Item img="/imgs/kwan/4.png" title="跨运营商穿透难、不稳定" />
        </div>
        <div className="flex gap-[40px] justify-between mt-[40px]">
          <Item
            img="/imgs/kwan/5.png"
            title="业务所需要的网络需求场景多，不灵活"
          />
          <Item img="/imgs/kwan/6.png" title="大量数据传输速度慢，延迟高" />
        </div>
      </div>
    </div>
  );
};

export const Item = (props: { img: string; title: string }) => {
  return (
    <div className="w-[700px] bg-gradient-to-r from-[#EDF9FC] via-[#F1F9FD] to-[#F5F8FF] rounded-[10px] px-[40px] py-[20px] flex items-center">
      <img
        className="w-[100px] min-w-[100px] h-[100px] bg-[#3B77FD] rounded-[12px] mr-[20px]"
        src={props.img}
      />
      <div>
        <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[25px] text-[#000000]">
          {props.title}
        </div>
      </div>
    </div>
  );
};
